import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {navbarGroup} from 'src/app/models/course-category.model';
import {AdminService} from 'src/app/services/admin.service';
import {TranslateService} from "@ngx-translate/core";

declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit {

  @Output() navToggle: EventEmitter<boolean> = new EventEmitter();

  public currentLang: string = 'de';


  dropdown: boolean = false;

  storedUrl: string = "/courses";
  navbarItems: any = navbarGroup;

  constructor(
    private router: Router,
    private adminService: AdminService,
    private route: ActivatedRoute,
    private readonly _translate: TranslateService
  ) {
    this.currentLang = localStorage.getItem('language') || 'de';
  }

  public getUrl(): void {
    const params = this.route.snapshot.queryParams;
    const baseUrl = '/programm/archiv';
    if (params['year']) {
      this.router.navigate(['/programm/archiv'], {queryParams: {year: params['year']}});
    } else {
      this.router.navigate([baseUrl]);
    }

  }

  ngOnInit(): void {
    $(document).ready(() => {
    });
  }

  isAdmin() {
    return this.adminService.isLoggedIn()
  }

  logout() {
    this.adminService.logout();
  }

  showSomething() {
    console.log("navbarGroupnavbarGroup", navbarGroup)
  }

  selectTab(id: any) {
    this.navbarItems = navbarGroup.map((navbarItem: any) => {
      if (navbarItem?.id === id) {
        this.storedUrl = navbarItem?.url;
        return {
          ...navbarItem,
          selected: true
        }
      }

      return {
        ...navbarItem,
        selected: false
      }
    })
  }

  navOpen() {
    this.navToggle.emit(true);
  }

  showMenu() {
    this.dropdown = !this.dropdown;
  }

  closeMenu() {
    this.dropdown = !this.dropdown;
  }

  openAbout(route: string) {
    this.router.navigateByUrl(route);
  }

  public handleLang(): void {
    this.currentLang = this.currentLang === 'de' ? 'en' : 'de';
    this._translate.use(this.currentLang);
    localStorage.setItem('language', this.currentLang);
  }

}
